const MODALS = {
	agency_detail: 'agency_detail',
	brutto_production: 'brutto_production',
	campaignSettings_templates: 'campaignSettings_templates',
	client_search: 'client_search',
	contact_take: 'contact_take',
	custom_settings: 'custom_settings',
	edit_guarantor: 'edit_guarantor',
	lead_task_history: 'lead_task_history',
	new_campaign: 'new_campaign',
	order: 'order',
	policy_search: 'policy_search',
	producedProduction_new: 'producedProduction_new',
	producedProduction_report: 'producedProduction_report',
	productionControl_report: 'productionControl_report',
	policyOverview_advanced_search: 'policyOverview_advanced_search',
	policyOverview_subordinate_login_search: 'policyOverview_subordinate_login_search',
	roboAdvisory_handover: 'roboAdvisory_handover',
	semaphore_feedback_detail: 'semaphore_feedback_detail',
	task_copy_email: 'task_copy_email',
	task_forwarding: 'task_forwarding',
	task_pszp_notice: 'task_pszp_notice',
	user_search: 'user_search',
	lightbox_modal: 'lightbox_modal',
};

export const modalsWithCheckBeforeClosingLightbox = [
	MODALS.agency_detail,
	MODALS.campaignSettings_templates,
	MODALS.client_search,
	MODALS.contact_take,
	MODALS.edit_guarantor,
	MODALS.new_campaign,
	MODALS.producedProduction_new,
	MODALS.producedProduction_report,
	MODALS.policyOverview_subordinate_login_search,
	MODALS.roboAdvisory_handover,
	MODALS.semaphore_feedback_detail,
	MODALS.task_copy_email,
	MODALS.task_forwarding,
];

export default MODALS;
